module.exports = __webpack_public_path__ + "static/media/location-white.4663f055.svg";